<template>
  <div class="page-container">
    <v-container>
      <v-row>
        <v-col cols="12">
          <!-- Hero Section -->
          <div class="hero-section mb-6">
            <h1 class="text-h4 font-weight-bold mb-2">
              Los mejores hosting para desarrolladores 2026
            </h1>
            <p class="text-subtitle-1 grey--text text--darken-1">
              Comparativa de los 5 hosting más usados por programadores Python, Java, .NET
              y tecnologías modernas.
            </p>
          </div>

          <v-divider class="my-6"></v-divider>

          <!-- Tabla comparativa -->
          <h2 class="text-h5 font-weight-medium mb-4">Comparativa completa</h2>
          <v-simple-table class="comparativa-table mb-6">
            <thead>
              <tr>
                <th>Hosting</th>
                <th>Precio inicial</th>
                <th>Mejor para</th>
                <th>Características destacadas</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong class="primary--text">Kinsta</strong></td>
                <td>$35/mes</td>
                <td>Proyectos profesionales</td>
                <td>Infraestructura Google Cloud, soporte 24/7, CDN incluido</td>
              </tr>
              <tr>
                <td><strong class="primary--text">WP Engine</strong></td>
                <td>$30/mes</td>
                <td>WordPress + desarrollo</td>
                <td>Entornos de staging, Git integrado, caché avanzada</td>
              </tr>
              <tr>
                <td><strong class="primary--text">SiteGround</strong></td>
                <td>$3.99/mes</td>
                <td>Proyectos pequeños</td>
                <td>Buen rendimiento por precio, soporte en español</td>
              </tr>
              <tr>
                <td><strong class="primary--text">DigitalOcean</strong></td>
                <td>$6/mes</td>
                <td>Desarrolladores avanzados</td>
                <td>VPS, control total del servidor, API potente</td>
              </tr>
              <tr>
                <td><strong class="primary--text">Heroku</strong></td>
                <td>$0 - $25/mes</td>
                <td>Proyectos en Python, Node.js, Ruby</td>
                <td>Despliegue fácil, ideal para pruebas y MVPs</td>
              </tr>
            </tbody>
          </v-simple-table>

          <!-- Recomendaciones por lenguaje -->
          <v-card class="pa-4 mb-6" elevation="2">
            <h3 class="text-h6 font-weight-medium mb-3">
              📌 ¿Cuál elegir según tu lenguaje?
            </h3>
            <v-row>
              <v-col cols="12" md="6">
                <v-list dense>
                  <v-list-item
                    ><strong>🐍 Python:</strong> Heroku, DigitalOcean,
                    PythonAnywhere</v-list-item
                  >
                  <v-list-item
                    ><strong>☕ Java:</strong> AWS Elastic Beanstalk, Heroku,
                    Kinsta</v-list-item
                  >
                </v-list>
              </v-col>
              <v-col cols="12" md="6">
                <v-list dense>
                  <v-list-item
                    ><strong>⚙️ .NET:</strong> Azure App Service,
                    SmarterASP.NET</v-list-item
                  >
                  <v-list-item
                    ><strong>🐘 PHP / WordPress:</strong> WP Engine, Kinsta,
                    SiteGround</v-list-item
                  >
                </v-list>
              </v-col>
            </v-row>
          </v-card>

          <v-alert type="info" class="mb-6">
            <strong>💡 Nuestra recomendación:</strong> Si valoras rendimiento y soporte,
            Kinsta es la mejor opción. Si buscas control total, DigitalOcean. Para
            proyectos pequeños o pruebas, Heroku o SiteGround son excelentes puntos de
            partida.
          </v-alert>

          <p class="text-caption text-center mt-4 grey--text">
            *Los precios pueden variar según promociones. Revisa siempre los términos de
            cada proveedor.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PaginaHostingComparativa",
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.page-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px 40px;
}
.hero-section {
  text-align: center;
}
.comparativa-table th {
  background-color: #f5f7fa;
  font-weight: 600;
  padding: 14px;
}
.comparativa-table td {
  padding: 12px;
  border-bottom: 1px solid #e8eef2;
}
.v-card {
  border-radius: 12px;
}
</style>
